import React, { useState } from 'react';
import { PlusIcon, MinusIcon } from 'lucide-react';
import { Eyebrow } from './Eyebrow';
import { FAQS } from '../data/landing';
export function FAQSection() {
  const [open, setOpen] = useState<number | null>(null);
  return <section className="bg-cream py-14 md:py-20" aria-labelledby="faq-title" data-id="element-26" data-mp="1ixj8mb8k96mn">
      <div className="mx-auto max-w-[1080px] px-5" data-id="element-27" data-mp="1nvkqwty5x1x2">
        <div className="mx-auto max-w-[560px] text-center" data-id="element-28" data-mp="2bkcbaz5igfza">
          <Eyebrow data-id="element-29" data-mp="2bkvv6leq1efy">Antes de preguntar</Eyebrow>
          <h2 id="faq-title" className="mt-4 text-[26px] leading-[1.15] sm:text-[34px] lg:text-[38px]" data-id="element-30" data-mp="2flpibckcap7s">
            Preguntas frecuentes
          </h2>
        </div>

        <ul className="mx-auto mt-8 max-w-[560px] space-y-2" data-id="element-31" data-mp="26tdve0ofpjwk">
          {FAQS.map((faq, index) => {
          const isOpen = open === index;
          return <li key={faq.q} className="overflow-hidden rounded-[12px] border border-line bg-cream-soft" data-id="element-32" data-mp="2uh5835dvzyyd" data-mpi={index}>
                <button type="button" onClick={() => setOpen(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-4 py-3.5 text-left" data-id="element-33" data-mp="1vqsyk15553l0">
                  <span className="text-[12px] font-bold text-ink md:text-[13px]" data-id="element-34" data-mp="20occt11u9gcy">
                    {faq.q}
                  </span>
                  {isOpen ? <MinusIcon className="h-3.5 w-3.5 flex-none text-gold" aria-hidden="true" data-id="element-35" data-mp="2ffl9fu45s1zl" /> : <PlusIcon className="h-3.5 w-3.5 flex-none text-ink-muted" aria-hidden="true" data-id="element-36" data-mp="2odneqluxdgso" />}
                </button>
                {isOpen && <p className="border-t border-line/70 px-4 py-3.5 text-[12px] font-medium leading-relaxed text-ink-muted md:text-[13px]" data-id="element-37" data-mp="p1kpsw3j7u7m">
                    {faq.a}
                  </p>}
              </li>;
        })}
        </ul>
      </div>
    </section>;
}